/**
 * ClientEditDialog – client settings editing dialog built on BaseDialog (Material Tailwind).
 * @see https://www.material-tailwind.com/docs/react/dialog
 */

import React, { useEffect } from 'react'
import { BaseDialog, IBaseDialogProps } from '../base-components/BaseDialog'

export interface IAjaxDialogProps extends IBaseDialogProps {
    modal: string
    params: URLSearchParams
}
// {
//     id,
//     showDialog,
//     onClose,
//     onSave,
//     headerContent,
//     bodyContent,
//     footerContent,
//     saveLabel = 'Save',
//     cancelLabel = 'Cancel',
//     hideFooter = false,
//     saveHidden = false,
//     saveDisabled = false,
//     className = '',
// }

export function AjaxDialog(props: IAjaxDialogProps) {

    console.log('AjaxDialog', props)

    const [data, setData] = React.useState<any>(null)
    const [header, setHeader] = React.useState<string>('')
    const [body, setBody] = React.useState<string>('')
    const [footer1, setFooter1] = React.useState<string>('')
    const [footer2, setFooter2] = React.useState<string>('')

    const getData = async (): Promise<boolean> => {
        const params = new URLSearchParams(props.params)
        const url = "ajax/modal/" + props.modal + ".modal.php"
        const response = await fetch(url + `?${params}`)

        const json = await response.json()
        console.log(json)

        setData(json)
        setHeader(json?.header ?? '')
        setBody(json?.body ?? '')
        setFooter1(json?.footer1 ?? '')
        setFooter2(json?.footer2 ?? '')
        return true
    }

    useEffect(() => {
        void getData()
    }, [])

    return (
        <BaseDialog
            {...props}
            headerContent={
                <div dangerouslySetInnerHTML={{ __html: header }} />
            }
            bodyContent={
                <div dangerouslySetInnerHTML={{ __html: body }} />
            }
            footerContent={
                <>
                    <button type='button' className='btn btn-default mr-auto close-btn'>{props.cancelLabel}</button>
                    {/* <button
                        type="button"
                        className="inline-flex items-center justify-center px-5 py-2.5 text-2xl font-medium
                            rounded-lg border border-border bg-muted text-foreground
                            hover:bg-muted/80 transition-colors cursor-pointer mr-auto"
                        onClick={props.onClose}
                    >
                        {props.cancelLabel}
                    </button> */}
                    <div dangerouslySetInnerHTML={{ __html: footer1 }} />
                    <div dangerouslySetInnerHTML={{ __html: footer2 }} />
                </>
            }
        ></BaseDialog>
    )
}
